import { createStateContext } from 'react-use';
import { getBaseLang } from './getBaseLang';

// 语言信息应该存储在 localStorage 避免刷新后，语言恢复

const [useGlobalLang, GlobalLangProvider] = createStateContext(getBaseLang());

export { useGlobalLang, GlobalLangProvider };
